
import basicUnidade from '../../_mock/basic_unidade.json'

const urlApiDev = process.env.API_BASE_URL_DEV
const urlApiProd = process.env.API_BASE_URL
const keyDev = process.env.DEV_UNIDADE_KEY
const keyProd = process.env.PROD_UNIDADE_KEY

const isDev = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'leonardo.senhadigitalplus.com.br',
  'link.senhadigitalplus.com.br',
].includes(window.location.hostname)

const urlApi = isDev ? urlApiDev : urlApiProd
const key = isDev ? keyDev : keyProd

const headers = {
  'x-api-key': `${key}`,
  'content-type': 'application/json',
}

const idCategoriaDev = "da0a49a3-d14c-4bdb-9038-da838ca20a43"
const idCategoriaProd = "1bf5eecc-db62-4043-a65b-a8bb2173a70e"
const idCategoria = isDev ? idCategoriaDev : idCategoriaProd

const storedUnidade = sessionStorage.getItem('unidade')
const storedNotConfigUnit = sessionStorage.getItem('notConfigUnit')
export const state = () => ({
  unidade: storedUnidade ? JSON.parse(storedUnidade) : null,
  notConfigUnit: storedNotConfigUnit ? JSON.parse(storedNotConfigUnit) : false,
})

export const getters = {
  unidadeInformation(state) {
    if (!state.unidade || !state.unidade.categoria) {
      return state.unidade;
    }

    const filter = state.unidade.categoria.filter(
      (e) => e.id !== idCategoria
    );
    return {
      ...state.unidade,
      categoria: filter,
    };
  },

  isSdconsulta(state) {
    if (!state.unidade.categoria) {
      return false;
    }
    const find = state.unidade.categoria.find((e) => e.id === idCategoria);
    console.log('find', find);
    return !find;
  }
  ,

  configUnit(state) {
    return state.notConfigUnit;
  },
};



export const mutations = {
  SET_UNIDADE(state, payload) {
    state.unidade = payload
    sessionStorage.setItem('unidade', JSON.stringify(payload))
  },
  NOTIFICATION_CONFIG_UNIT(state, payload) {
    state.notConfigUnit = payload
    sessionStorage.setItem('notConfigUnit', JSON.stringify(payload))
  },
  CLOSE_DIALOG_STATUS(state, status) {
    if (state.unidade && state.unidade.dialog) {
      state.unidade.dialog.status = status
      sessionStorage.setItem('unidade', JSON.stringify(state.unidade))
    }
  },
}

export const actions = {
  async fetchUnidade({ commit }, { url }) {
    const data = await this.$axios.$get(`${urlApi}/unidade-open/v1`, {
      headers,
      params: {
        unidade: url,
      },
    })
    const returnData = !data ? basicUnidade : data

    if (!data) {
      commit('NOTIFICATION_CONFIG_UNIT', true)
    }

    if (!returnData.status) {
      window.location.href = `https://${returnData.redirect}`
      return
    }

    commit('SET_UNIDADE', returnData)
  },

  async createAtendimentoExpress({ commit }, dados) {
    const data = await this.$axios.$post(`${urlApi}/unidade/v1/express`, dados)
    return data
  },

  async getAtendimentoExpress({ commit }, idTransacao) {
    const data = await this.$axios.$get(`${urlApi}/unidade/v1/express/${idTransacao}`)
    return data
  },
}
